<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="editable-label">
    <div
      v-if="isEditing"
      class="full-screen-blur"
      @click="cancel" />
    <span
      v-if="!isEditing"
      :style="useFullWidth ? 'flex-basis: 100%;' : ''"
      @click="labelClicked"
      >{{ internalLabel || placeholder }}</span
    >
    <template v-if="!isReadOnly">
      <input
        v-if="isEditing"
        ref="labelInput"
        v-model="internalLabel"
        type="text"
        style="z-index: 11"
        @keydown="handleKeyDown"
        @focus="handleFocus"
        @blur="handleBlur" />
      <button
        v-if="!isEditing"
        class="btn btn-no-text"
        :class="`${buttonSizeClass} ${buttonColorClass}`"
        @click.prevent="editLabel">
        <icon-edit />
      </button>
      <button
        v-if="isEditing"
        class="btn btn-default btn-no-text"
        :class="buttonSizeClass"
        style="z-index: 11"
        @click.prevent="confirm">
        <icon-check-2 />
      </button>
      <button
        v-if="isEditing"
        class="btn btn-danger btn-no-text"
        :class="buttonSizeClass"
        style="z-index: 11"
        @click.prevent="cancel">
        <icon-close />
      </button>
    </template>
  </div>
</template>

<script type="text/babel" lang="ts">
  import { IconCheck2, IconClose, IconEdit } from '@/common/icons/monochrome';

  export default {
    name: 'EditableLabel',
    components: {
      IconCheck2,
      IconClose,
      IconEdit,
    },
    props: {
      label: {
        type: String,
      },
      enableEditOnLabelClick: {
        type: Boolean,
        default: true,
      },
      isReadOnly: {
        type: Boolean,
        default: false,
      },
      buttonSizeClass: {
        type: String,
        default: 'btn-xs',
      },
      buttonColorClass: {
        type: String,
        default: 'btn-default',
      },
      useFullWidth: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        internalLabel: '',
        isEditing: false,
        previousLabel: null,
      };
    },
    watch: {
      internalLabel(val) {
        this.$emit('changed', val);
      },
      label(val) {
        if (val !== this.internalLabel) {
          this.internalLabel = val;
        }
      },
    },
    mounted() {
      this.internalLabel = this.label;
    },
    methods: {
      editLabel() {
        if (this.isReadOnly) {
          return;
        }
        this.isEditing = true;
        setTimeout(() => {
          this.$refs.labelInput.focus();
          this.$refs.labelInput.select();
        }, 100);
      },
      labelClicked() {
        if (this.enableEditOnLabelClick) {
          this.editLabel();
        }
      },
      handleBlur() {
        setTimeout(() => {
          if (this.isEditing) {
            this.isEditing = false;
          }
        }, 200);
      },
      handleFocus() {
        this.previousLabel = this.internalLabel;
      },
      handleKeyDown(e) {
        if (e.keyCode === 13) {
          this.confirm();
        } else if (e.keyCode === 27) {
          this.cancel();
        }
      },
      confirm() {
        this.isEditing = false;
        this.$emit('confirmed-change', this.internalLabel);
      },
      cancel() {
        this.internalLabel = this.previousLabel;
        this.isEditing = false;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .editable-label {
    display: flex;
    align-items: center;
    width: 100%;

    input {
      flex-grow: 1;
      min-width: 0;
      flex-shrink: 1;
      width: 0;
      margin-right: 0.6rem;
      outline: none;
    }

    span {
      margin-right: 0.6rem;
    }

    .btn {
      margin-right: 0.3rem;
      min-width: 2.4rem;
      display: flex;
      align-items: center;
      justify-content: center;

      &:last-of-type {
        margin-right: 0.8rem;
      }
    }

    .full-screen-blur {
      z-index: 10;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.25);
      opacity: 0;
      cursor: default;
      animation-name: opacifyAnimation;
      animation-duration: 1.5s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }
  }
</style>
